<template>
	<modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
		<h3 slot="header" class="mb-0 font-weight-500">Detail Role Access</h3>
		<b-row>
			<!-- FIELD ROLE NAME -->
			<b-col cols="12" class="mb-2">
				<strong>Role Name :</strong>
				<p>{{data_form.role_name}}</p>
			</b-col>
			<!-- FIELD ROLE Group Type -->
			<b-col cols="12" class="mb-2">
				<strong>Role Group Type :</strong>
				<p>{{data_form.role_type}}</p>
			</b-col>
			<b-col cols="12" class="mb-2">
				<strong>Role Level Squence :</strong>
				<p>{{data_form.level}}</p>
			</b-col>
			<b-col cols="12" class="mb-2">
				<strong>Forfeits Commission :</strong>
				<p>{{ data_form.is_forfeits == 1 ? 'Open - Yes Forfeits' : 'Closed - No Forfeits' }}</p>
			</b-col>
			<!-- FIELD ROLE DESCRIPTION -->
			<b-col cols="12" class="mb-2">
				<strong>Role Description :</strong>
				<p>{{data_form.role_description}}</p>
			</b-col>
			<!-- FIELD ROLE DESCRIPTION -->
			<b-col cols="12" class="mb-2">
				<strong>Role Access :</strong>
				<div v-for="mGroup in getRoleAccessLabels">
					<h5>{{ mGroup.group_name }}</h5>
					<ul>
						<li v-for="aItem in mGroup.group_access">{{ aItem.label }}</li>
					</ul>
				</div>
			</b-col>
		</b-row>
	</modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, CheckboxGroup, Checkbox } from 'element-ui'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import _ from 'lodash'

export default {
	props: {
		detail_role_access: Boolean,
		role_item: {
			type: Object
		},
		available_group_access: Array
	},
	mixins: [
		notifyFunctionMixin,
		helperFunctionMixin
	],
	components: {
		Modal,
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
		[CheckboxGroup.name]: CheckboxGroup,
		[Checkbox.name]: Checkbox,
	},
	computed: {
		show: {
			get() {
				return this.detail_role_access;
			},
			set(newVal) {
				this.$emit('update:detail_role_access', newVal);
			},
		},
		getRoleAccessLabels(){
			let current_access = this.data_form.role_access;
			let available_group_access = this.available_group_access;
			let results = [];
			if(current_access){
				results =_.filter(_.map(available_group_access, function(o){
					let group_access = _.filter(o.group_access, function(y){
						return (current_access.indexOf(y.access_code) !== -1);
					});
					return {
						"group_code" : o.group_code,
						"group_name" : o.group_name,
						"group_access" : group_access,
					}					
				}), x => ((x.group_access).length > 0));
			}
			return results;
		}
	},
	data() {
		return {
			data_form: {
				role_id: '',
				role_name: '',
				role_type: '',
				role_description: '',
				role_access: [],
			},
			typeOptions: [
				{
					value: 'admin',
					label: 'Admin',
				},
				{
					value: 'manager',
					label: 'Manager',
				},
				{
					value: 'sales',
					label: 'Sales',
				},
				{
					value: 'director',
					label: 'Director',
				},
				{
					value: 'agent',
					label: 'Agent',
				},
				{
					value: 'main',
					label: 'Main Status'
				}, {
					value: 'sub',
					label: 'Sub Status'
				}
			]
		}
	},
	async created() {
		this.$watch(
			() => this.role_item,
			(newVal) => {
				if (newVal) {
					this.data_form.role_id = newVal.role_id ?? '';
					this.data_form.role_name = newVal.role_name ?? '';
					this.data_form.role_type = newVal.role_type ?? '';
					this.data_form.is_forfeits = newVal.is_forfeits ?? '';
					this.data_form.role_description = newVal.role_description ?? '';
					this.data_form.role_access = (newVal.role_access) ?? [];
				}
			},
			{ immediate: true }
		)
	},
	methods: {
		
	}
}
</script>